import $api from "..";
import { AxiosResponse } from "axios";
import { IAddTeamDisplay } from "../common/api_interfaces/project/IAddTeamMembers";
import { ITeamDisplay } from "../common/api_interfaces/project/ITeamDisplay";
import { IDeleteTeamDisplay } from "../common/api_interfaces/project/IDeleteTeamMembers";

export default class TeamService {
    async addTeamMembers(body: IAddTeamDisplay): Promise<AxiosResponse<ITeamDisplay>> {
        return $api.post<ITeamDisplay>("/Project/addTeamMembers", body);
    }

    async deleteTeamMembers(body: IDeleteTeamDisplay): Promise<AxiosResponse<void>> {
        return $api.post(`/Project/deleteTeamMembers`, body);
    }
}
